

export const AreSceneStatuses = {
    Active: 'active',
    Inactive: 'inactive',
    Destroyed: 'destroyed',
}